<template>
  <div v-show="isLoaded" class="mBanner-container" v-observe-visibility="startAnimate">
    <img class="mBanner-image" :src="banner" alt="Banner">
    <img class="mBanner-image-desktop" :src="banner_desktop" alt="Banner">
    <h1 class="mBanner-title" :class="{animate: animate, onlySafari: isSafari}">
        Experiencia
    </h1>
    <h2 class="mBanner-subtitle" :class="{animate: animate, onlySafari: isSafari}">
        Cider
    </h2>
    <h3 class="mBanner-title-desktop" :class="{animate: animate}">Experiencia Cider</h3>
    <img class="mBanner-botellas" v-observe-visibility="startAnimate" :src="botellas" :class="{animate: animate}" alt="Botellas banner">
    <div class="mBanner-container">
      <a class="mBanner-chevron" href="javascript:void(0)"></a>
      <a class="mBanner-chevron" href="javascript:void(0)"></a>
      <a class="mBanner-chevron" href="javascript:void(0)"></a>
    </div>
  </div>
</template>

<script>
import banner from '@/assets/banner_2.png';
import banner_desktop from '@/assets/bannerh_desktop.png';
import botellas from '@/assets/EC_botellas.png';
import { mapGetters } from "vuex";
import Bowser from "bowser"; 

export default {
  name: "Banner",
  data() {
    return {
      banner,
      banner_desktop,
      botellas,
      animate: false,
      isSafari: false
    };
  },
      computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible){
      if(isVisible){
        this.animate=true
      }
      
    }
  },
  components: {},
  beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName()=='Safari') {
      this.isSafari = true
}
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/Banner.scss";
</style>
